export default function TemplatePresentialCourse(props) {
  return null;
}
